import { supabase } from "@/integrations/supabase/client";

interface SpotImageProps {
  images: string[];
}

const SpotImage = ({ images }: SpotImageProps) => {
  if (!images || images.length === 0) return null;

  return (
    <img
      src={`${supabase.storage
        .from("parking-spots")
        .getPublicUrl(images[0]).data.publicUrl}`}
      alt="Parking spot"
      className="w-full h-48 object-cover rounded-md"
    />
  );
};

export default SpotImage;